export default __webpack_public_path__ + "static/media/plbgcircle1.3d26789e.png";